import ReduxRestEntity from '../../../../utils/reduxRestEntity';
import entity from './entity';

const coreReducer = entity.getReducer();

const initialState = {
  ...ReduxRestEntity.initialState,
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    default:
      return coreReducer(state, action);
  }
};

export default reducer;
